import { makeRequest } from "../baseApi";
import { consoleLogGroup } from "../../utils/console";
import { parseResponseDefault } from "../not-sorted.utils";
import { parseResponseFakeRelatedSearchSuggestions } from "./utils";
import { makeParamsString } from "../utils";

export const getTextDetectedLanguagesRequest = (text, languagesToDetectIn) => {
  return makeRequest({
    url:
      "/suggestions/detect?" +
      makeParamsString(
        {
          text,
          language: languagesToDetectIn,
        },
        true,
      ),
    memoryCache: true,
    parseResponse: parseResponseDefault,
  });
}; // make default count 100 for avoid multiple call

export const getSuggestionsPopupRequest = async (searchValue, lang, count = 100) => {
  const result = await makeRequest({
    url: `/suggestions/popup/${lang}?query=${encodeURIComponent(searchValue)}&count=${count}`,
    type: "get",
    memoryCache: true,
    memoryCacheName: "SG-" + lang + "-" + searchValue + "-" + count,
    parseResponse: parseResponseDefault,
  });
  // consoleLogGroup(`🙋‍ SG ${searchValue} (${lang || "no lang"}) [${count}]`, result);
  return result;
};

export const fetchFakeRelatedSearchSuggestions = async (searchValue, lang, count = 100) => {
  const result = await getSuggestionsPopupRequest(searchValue, lang, count);
  return parseResponseFakeRelatedSearchSuggestions(result);
};
